module.exports = __webpack_public_path__ + "img/infernal_machine_small.bcdd20c9.png";